import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import FeatureFlagService from '../../../api/services/FeatureFlagService';
import { FeatureFlag } from '../../../api/types';
import { RootState } from '../../../store';

const ACTIONS_PREFIX = 'featureFlag';

type FeatureFlagState = {
  featureFlags: FeatureFlag[];
};

const initialState: FeatureFlagState = {
  featureFlags: [],
};

export const getFeatureFlagsThunk = createAsyncThunk(
  `${ACTIONS_PREFIX}/getFeatureFlags`,
  FeatureFlagService.getFeatureFlags,
);

const featureFlagSlice = createSlice({
  name: 'featureFlag',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeatureFlagsThunk.fulfilled, (state, action) => {
      state.featureFlags = (action.payload.resource as FeatureFlag[]) || [];
    });
  },
});

export const featureFlagsState = (state: RootState) => state.featureFlags;
export default featureFlagSlice.reducer;
